import React from "react";
import { Alert } from "react-bootstrap";

export default function RaportProfitDevize() {
  return (
    <div className="bg-white p-3 rounded shadow-sm">
      <p className="text-muted">Analizează profitabilitatea fiecărui deviz auto în funcție de costul pieselor, valoarea facturată și manopera mecanicilor.</p>
      <Alert variant="info">Modul în curs de dezvoltare.</Alert>
    </div>
  );
}
